<!-- Loader-->
<div class="div-window_maps_title" *ngIf="!isLoaded">
  <div class="h3 loaderH3">My Profile</div>
  <div id="loadingText" class="h5">Loading...</div>
</div>
<div id="profilediv" *ngIf="isLoaded">
  <!-- Profile Div -->
  <div
    class="div-window"
    [ngClass]="!isEdit ? 'div-window' : 'div-window1'"
    [ngClass]="isEditPassword ? 'div-window2' : 'null'"
  >
    <div class="h3 profile">
      Profile
      <button
        class="text-btn edit_btn"
        (click)="editProfile($event)"
        id="update-profile"
        *ngIf="!isEdit"
      >
        Edit
      </button>
      <p class="shown-profile-form required" *ngIf="isEdit && !isEditPassword">
        Name and email are required
      </p>
    </div>
    <div *ngIf="isEdit">
      <form
        id="update-user "
        [formGroup]="!isEditPassword ? profileForm : passwordForm"
        (ngSubmit)="!isEditPassword ? submitProfile() : changePassword()"
      >
        <div class="shown-profile-form" *ngIf="!isEditPassword">
          <input
            type="text"
            name="first_name"
            placeholder="Administrator first name "
            class="payment-inputs full_lenght_inputs"
            id="firstname"
            formControlName="first_name"
            required
          />
          <input
            type="text"
            name="last_name"
            placeholder="Administrator last name "
            class="payment-inputs full_lenght_inputs"
            id="lastname"
            formControlName="last_name"
            required
          />
          <input
            type="text"
            name="email"
            placeholder="Email"
            class="payment-inputs full_lenght_inputs"
            id="email"
            formControlName="email"
          />
        </div>
        <!-- <a id="change-password" (click)="editPassword()">Change Password</a> -->
        <div *ngIf="isEditPassword">
          <h6>Change Password</h6>
          <input
            type="password"
            name="old_password"
            placeholder="Current Password"
            class="payment-inputs full_lenght_inputs"
            id="id_old_password"
            formControlName="current_password"
            [ngClass]="!oldPasswordMatch ? 'error1' : 'null'"
          />

          <input
            type="password"
            name="new_password1"
            placeholder="Choose Password"
            class="payment-inputs full_lenght_inputs"
            id="id_new_password1"
            required
            formControlName="new_password"
          />

          <input
            type="password"
            name="new_password2"
            placeholder="Repeat Chosen Password"
            class="payment-inputs full_lenght_inputs"
            id="id_new_password2"
            required
            formControlName="new_password_2"
            [ngClass]="!passwordMatch ? 'error2' : 'null'"
          />
        </div>
        <div class="shown-profile-form" *ngIf="!isEditPassword">
          <input
            type="text"
            name="phone"
            placeholder="Phone (optional, but needed for providing support) "
            class="payment-inputs full_lenght_inputs"
            id="id_phone"
            formControlName="phone_number"
          />
          <input
            type="text"
            name="company"
            placeholder="Organization (optional)"
            class="payment-inputs full_lenght_inputs"
            id="id_company"
            formControlName="organization"
          />
          <select
            [(ngModel)]="selectedIndustry"
            name="device"
            class="select payment-inputs full_lenght_inputs"
            id="id_device"
            formControlName="industry"
          >
            <!-- <option value="" select>Industry</option> -->
            <option
              *ngFor="let industryList of industry"
              value="{{ industryList.value }}"
            >
              {{ industryList.name }}
            </option>
          </select>
        </div>
        <div>
          <button
            (click)="back()"
            class="btn gernal-btn backBtn"
            [ngClass]="isEditPassword ? 'accept-btn' : 'accept-btn1'"
          >
            Back
          </button>
          <button
            type="submit "
            class="btn gernal-btn"
            [ngClass]="isEditPassword ? 'accept-btn' : 'accept-btn1'"
            [disabled]="isEditPassword && !passwordForm.valid"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
    <!-- Edit profile form ending here -->
    <div class="profile row-payment edit_profile" *ngIf="!isEdit">
      <div>
        <div>
          <div class="line-margin">
            <p class="p2">Name:</p>
            <p class="name add-ons-div">
              {{
                profileInfo.profile.first_name +
                  " " +
                  profileInfo.profile.last_name
              }}
            </p>
          </div>
          <div class="line-margin">
            <p class="p2">Email:</p>
            <p class="email add-ons-div">
              {{ profileInfo.profile.user_email }}
            </p>
          </div>
          <div class="line-margin">
            <p class="p2">Password:</p>
            <p class="pass add-ons-div">********{{ " " }}</p>
            <a id="change-password" (click)="editPassword()">Change Password</a>
          </div>
          <div class="line-margin">
            <p class="p2">Phone:</p>
            <p class="phone add-ons-div">
              {{ profileInfo.profile.user_phone }}
            </p>
          </div>
          <div class="line-margin">
            <p class="p2">Organization:</p>
            <p class="organization add-ons-div">
              {{ profileInfo.profile.organization }}
            </p>
          </div>
          <div class="line-margin">
            <p class="p2">Industry:</p>
            <p class="industry add-ons-div">
              {{ profileInfo.profile.industry }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Payment Div -->

  <div
    *ngIf="paymentInfo"
    [ngClass]="
      !isEditPayment && paymentInfo.payment_info
        ? 'div-window-payment'
        : 'div-window-payment1'
    "
    [ngClass]="
      !paymentInfo.payment_info && !isEditPayment
        ? 'div-window-payment2'
        : 'div-window-payment'
    "
  >
    <div>
      <div class="h3 payment_information">
        Payment Information
        <button
          class="text-btn payment edit_btn"
          id="card-edit"
          (click)="editPayment($event)"
          *ngIf="!isEditPayment"
        >
          Edit
        </button>
        <p class="required" *ngIf="isEditPayment">All fields are required</p>
      </div>
      <p
        class="payment"
        style="display: block"
        *ngIf="!paymentInfo.payment_info && !isEditPayment"
      >
        Enter payment information to become a subscriber.
      </p>
    </div>
    <form
      id="update-payment"
      [formGroup]="paymentForm"
      (ngSubmit)="submitPayment()"
    >
      <app-payment *ngIf="isEditPayment" class="applyNewCss"></app-payment>

      <div
        class="payment row-payment"
        *ngIf="!isEditPayment && paymentInfo.payment_info"
      >
        <div>
          <div class="line-margin">
            <p class="p2 add-ons-div1">Card Holder:</p>
            <p class="add-ons-div">
              {{
                paymentInfo.payment_info.first_name +
                  " " +
                  paymentInfo.payment_info.last_name
              }}
            </p>
          </div>
          <div class="line-margin">
            <p class="p2 add-ons-div1">Card Number:</p>
            <p class="add-ons-div card_number">
              {{ paymentInfo.payment_info.card_number }}
            </p>
            <p class="p2 exp add-ons-div1">Exp:</p>
            <p class="add-ons-div">
              {{ paymentInfo.payment_info.expiry_date }}
            </p>
          </div>
        </div>
      </div>
      <div>
        <div *ngIf="!isEditPayment && paymentInfo.payment_info">
          <img
            class="poweredbyrecurly"
            src="/assets/img/recurly/powered_recurly.png "
          />
          <div id="trust_wave">
            <img
              id="trustwaveSealImage"
              src="https://sealserver.trustwave.com/seal_image.php?customerId=0264d9320c65430c91210dc056604719&amp;size=105x54&amp;style=invert "
              border="0 "
            />
          </div>
          <img
            class="poweredbyrecurly img_width poweredbyrecurlyImage"
            src="/assets/img/recurly/TSYS.png "
          />
        </div>
        <div
          *ngIf="paymentInfo.payment_info"
          [ngClass]="!isEditPayment ? 'next_bill_div' : 'next_bill_div1'"
        >
          <div>
            <p class="p2 add-ons-div1">Next Billing:</p>
            <p class="add-ons-div next_billing">
              {{ paymentInfo.payment_info.next_monthly_billing_date }}
            </p>
            <a
              class="payment_histroy"
              id="payment_history"
              (click)="openDialog()"
              >View Payment history</a
            >
          </div>
        </div>
        <div *ngIf="isEditPayment && paymentInfo.payment_info">
          <button
            (click)="backPayment($event)"
            class="btn accept-btn gernal-btn"
          >
            Back
          </button>
          <button type="submit " class="btn accept-btn gernal-btn">
            Submit
          </button>
        </div>
      </div>
      <!-- if user has no payment data then on edit payment button -->

      <div
        *ngIf="isEditPayment && !paymentInfo.payment_info"
        style="margin-top: 60px !important"
      >
        <button (click)="backPayment($event)" class="btn accept-btn gernal-btn">
          Back
        </button>
        <button type="submit " class="btn accept-btn gernal-btn">Submit</button>
      </div>
    </form>

  </div>
</div>

